export default __webpack_public_path__ + "static/media/nightcity.b9d2f20c.jpg";